import { PostHogProvider } from "@posthog/react";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router";
import { PersistGate } from "redux-persist/integration/react";
import { AppThemeProvider } from "./common/contexts/theme-provider";
import { posthog } from "./common/lib/posthog";
import { rootRouter } from "./common/navigations/root-router";
import { persistor, store } from "./common/redux/store";

export function App() {
	return (
		<HelmetProvider>
			<Provider store={store}>
				<PersistGate persistor={persistor}>
					<PostHogProvider client={posthog}>
						<AppThemeProvider>
							<RouterProvider router={rootRouter} />
						</AppThemeProvider>
					</PostHogProvider>
				</PersistGate>
			</Provider>
		</HelmetProvider>
	);
}
